
import TimeUtil from 'utils/time-util'
import * as Yup from 'yup'
import { PURPOSE } from 'domains/internal-request/constants'


/** Internal Request Borrow Form schema */
const internalRequestBorrowSchema = Yup.object().shape({
  purpose: Yup.string().oneOf(
    Object.values(PURPOSE),
    `Must be one of this value: ${Object.values(PURPOSE).join(', ')}`
  ).required('Required'),
  requested_date : Yup.date().min(TimeUtil.yesterday(), 'Requested date must be today or future date').required('Required'),
  returned_date  : Yup.date()
    .when(
      'requested_date',
      (requested_date, schema) => requested_date && schema.min(requested_date, 'Returned date should be greater than borrow date')
    )
    .required('Required'),
  preorder_date: Yup.date()
    .when(
      'returned_date',
      (returned_date, schema) => returned_date && schema.min(returned_date, 'Preoreder date should be greater than or equal with return date')
    ),
  selected_inventories: Yup.array().min(1, 'at least there\'s one borrowed Inventory')
})

export default internalRequestBorrowSchema
